<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card :loading="loading" elevation="0" class="mx-auto">
          <v-card-title>Image categories</v-card-title>
          <v-card-text>
            <div class="my-2 subtitle-1">
              <span
                v-show="result.category.length"
                class="subtitle-1"
                v-for="(categ, index) in result.category"
                :key="index"
              >
                {{ categ
                }}{{ index === result.category.length - 1 ? "." : "," }}
              </span>
              <span v-show="!result.category.length">-</span>
            </div>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-title>Image colors</v-card-title>
          <v-card-text>
            <span v-show="!result.color.length">-</span>
            <v-chip
              v-show="result.color.length"
              small
              v-for="(color, index) in result.color"
              :key="index"
              dark
              class="mx-1 my-2"
            >
              {{ color }}
            </v-chip>
          </v-card-text>
          <v-divider class="mx-4"></v-divider>
          <v-card-title>Algorithm detect colors</v-card-title>
          <v-card-text>
            <v-chip
              small
              v-for="(color, index) in result.input_img_rgb.rgb"
              :key="index"
              dark
              :color="`rgba(${color[0]})`"
              class="mx-1 elevation-2 my-2"
              style="
                border: 1px solid grey;
                background-image: linear-gradient(
                  to right,
                  transparent,
                  #ffffff2b,
                  transparent
                );
              "
            >
            </v-chip>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "progress",
  data() {
    return {
      loading: false,
      selection: 1,
    };
  },
  props: {
    result: null,
    products: null,
  },
  methods: {},
};
</script>
